import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Success = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('payment_success')}</title>
      </Helmet>
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>{t('payment_success')}</h1>
        <p>{t('thank_you_message')}</p>
      </div>
    </>
  );
};

export default Success;
